var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.id ? "修改提货点" : "添加提货点",
            visible: _vm.dialogFormVisible,
            width: "750px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.cancel,
          },
          model: {
            value: _vm.dialogFormVisible,
            callback: function ($$v) {
              _vm.dialogFormVisible = $$v
            },
            expression: "dialogFormVisible",
          },
        },
        [
          _vm.dialogFormVisible
            ? [
                _c(
                  "el-form",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      model: _vm.ruleForm,
                      rules: _vm.rules,
                      "label-width": "100px",
                    },
                    nativeOn: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "提货点名称：", prop: "name" } },
                      [
                        _c("el-input", {
                          staticClass: "dialogWidth",
                          attrs: {
                            maxlength: "40",
                            placeholder: "请输入提货点名称",
                          },
                          model: {
                            value: _vm.ruleForm.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "name", $$v)
                            },
                            expression: "ruleForm.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "提货点简介：" } },
                      [
                        _c("el-input", {
                          staticClass: "dialogWidth",
                          attrs: {
                            maxlength: "100",
                            placeholder: "请输入提货点简介",
                          },
                          model: {
                            value: _vm.ruleForm.introduction,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "introduction", $$v)
                            },
                            expression: "ruleForm.introduction",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "提货点手机号：", prop: "phone" } },
                      [
                        _c("el-input", {
                          staticClass: "dialogWidth",
                          attrs: { placeholder: "请输入提货点手机号" },
                          model: {
                            value: _vm.ruleForm.phone,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "phone", $$v)
                            },
                            expression: "ruleForm.phone",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "所属团长：", prop: "promoterId" } },
                      [
                        _c(
                          "div",
                          { staticClass: "acea-row row-middle" },
                          [
                            _vm.ruleForm.promoterId
                              ? _c(
                                  "span",
                                  { staticClass: "mr15 promoter-selected" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.ruleForm.promoterName) +
                                        "（ID:" +
                                        _vm._s(_vm.ruleForm.promoterId) +
                                        "）"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small" },
                                on: { click: _vm.openPromoterDialog },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.ruleForm.promoterId
                                      ? "重新选择"
                                      : "选择团长"
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "提货点地址：", prop: "address" } },
                      [
                        _c("el-cascader", {
                          staticClass: "dialogWidth",
                          staticStyle: { width: "100%" },
                          attrs: {
                            clearable: "",
                            options: _vm.addresData,
                            props: {
                              value: "name",
                              label: "name",
                              children: "child",
                              expandTrigger: "hover",
                            },
                          },
                          on: { change: _vm.handleChange },
                          model: {
                            value: _vm.ruleForm.address,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "address", $$v)
                            },
                            expression: "ruleForm.address",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "详细地址：", prop: "detailedAddress" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "address-input-group" },
                          [
                            _c("el-input", {
                              staticClass: "address-input",
                              attrs: {
                                placeholder: "请输入详细地址后点击搜索地址",
                              },
                              model: {
                                value: _vm.ruleForm.detailedAddress,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "detailedAddress", $$v)
                                },
                                expression: "ruleForm.detailedAddress",
                              },
                            }),
                            _c(
                              "el-button",
                              {
                                staticClass: "search-btn",
                                attrs: { type: "primary", size: "small" },
                                on: { click: _vm.searchLocation },
                              },
                              [_vm._v("搜索地址")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "提货点营业：" } },
                      [
                        _c("el-time-picker", {
                          attrs: {
                            "is-range": "",
                            "range-separator": "至",
                            "start-placeholder": "开始时间",
                            "end-placeholder": "结束时间",
                            placeholder: "请选择时间营业时间",
                            "value-format": "HH:mm:ss",
                          },
                          on: { change: _vm.onchangeTime },
                          model: {
                            value: _vm.dayTime,
                            callback: function ($$v) {
                              _vm.dayTime = $$v
                            },
                            expression: "dayTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "提货点logo：", required: true } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "upLoadPicBox",
                            on: {
                              click: function ($event) {
                                return _vm.modalPicTap("1")
                              },
                            },
                          },
                          [
                            _vm.ruleForm.image
                              ? _c("div", { staticClass: "pictrue" }, [
                                  _c("img", {
                                    attrs: { src: _vm.ruleForm.image },
                                  }),
                                ])
                              : _c("div", { staticClass: "upLoad" }, [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-camera cameraIconfont",
                                  }),
                                ]),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "经纬度：", prop: "latitude" } },
                      [
                        _c("el-input", {
                          staticClass: "dialogWidth",
                          attrs: {
                            placeholder: "在下方地图点击选择位置",
                            readonly: "",
                          },
                          model: {
                            value: _vm.ruleForm.latitude,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "latitude", $$v)
                            },
                            expression: "ruleForm.latitude",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-form-item", { attrs: { label: "地点定位：" } }, [
                      _c("div", { staticClass: "addpoint-map-container" }, [
                        _c("div", {
                          staticClass: "addpoint-amap",
                          attrs: { id: "addPointAmapContainer" },
                        }),
                      ]),
                      _c("div", { staticClass: "addpoint-map-tip" }, [
                        _vm._v(
                          "在地图上点击可选择位置，或输入详细地址后点击“搜索地址”定位"
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { attrs: { slot: "footer" }, slot: "footer" },
                  [
                    _c("el-button", { on: { click: _vm.cancel } }, [
                      _vm._v("取 消"),
                    ]),
                    _vm.id
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:system:store:update"],
                                expression: "['admin:system:store:update']",
                              },
                            ],
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.editForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v("修改")]
                        )
                      : _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:system:store:save"],
                                expression: "['admin:system:store:save']",
                              },
                            ],
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.submitForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v("提交")]
                        ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加团长",
            visible: _vm.promoterDialog,
            width: "900px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.promoterDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "用户搜索：" } },
                [
                  _c("UserSearchInput", {
                    on: { searchList: _vm.promoterSearch },
                    model: {
                      value: _vm.promoterFrom,
                      callback: function ($$v) {
                        _vm.promoterFrom = $$v
                      },
                      expression: "promoterFrom",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.promoterSearch },
                },
                [_vm._v("搜索")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "ml10",
                  attrs: { size: "small" },
                  on: { click: _vm.resetPromoterSearch },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.promoterLoading,
                  expression: "promoterLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.promoterList, size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { width: "145", label: "ID" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-radio", {
                          attrs: { label: scope.row.uid },
                          on: {
                            change: function () {
                              return _vm.selectPromoterRow(scope.row)
                            },
                          },
                          model: {
                            value: _vm.promoterRadio,
                            callback: function ($$v) {
                              _vm.promoterRadio = $$v
                            },
                            expression: "promoterRadio",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "头像", "min-width": "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-image", {
                          staticStyle: { width: "36px", height: "36px" },
                          attrs: {
                            src: scope.row.avatar,
                            "preview-src-list": [scope.row.avatar],
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "nickname", label: "姓名", "min-width": "160" },
              }),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "手机号", "min-width": "140" },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "acea-row row-right mt20" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.promoterFrom.limit,
                  "current-page": _vm.promoterFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.promoterTotal,
                },
                on: {
                  "size-change": _vm.promoterSizeChange,
                  "current-change": _vm.promoterPageChange,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.promoterDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmPromoter },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }